import { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";

function Login() {
  const [data, setData] = useState({ mobile: "", password: "" });

  const navigate = useNavigate();

  const handleLogin = async () => {
     try {
    const res = await fetch(
      "https://citrine-backend-0hws.onrender.com/api/login",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      },
    );
    const result = await res.json();

    if (!res.ok) {
      alert(result.error || "Login failed");
      return;
    }
    localStorage.setItem("token", result.token);
    // Optional: save user info if needed
    localStorage.setItem("user", JSON.stringify(result.user));

    // ✅ Dispatch events AFTER token is saved
    window.dispatchEvent(new Event("authChanged"));
    window.dispatchEvent(new Event("cartUpdated"));

    alert("Login successful");
    navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-title">Login</div>

        <input
          className="login-input"
          placeholder="Mobile No."
          onChange={(e) => setData({ ...data, mobile: e.target.value })}
        />

        <input
          className="login-input"
          type="password"
          placeholder="Password"
          onChange={(e) => setData({ ...data, password: e.target.value })}
        />

        <button className="login-button" onClick={handleLogin}>
          Login
        </button>

        <div className="login-footer">
          Don't have an account?{" "}
          <span onClick={() => navigate("/register")}>Register</span>
        </div>
      </div>
    </div>
  );
}

export default Login;
